import './Legal.css';
import SEO from '../../components/SEO/SEO';

function CookiePolicy() {
    return (
        <div className='legal_container padding_top padding_bottom'>
            <SEO
                title="Cookie Policy"
                description="Learn about how PrepWize uses cookies to improve your experience and provide personalized features."
                url="https://prepwize.ai/cookie-policy"
            />
            <div className='all_margin'>
                <div className='margin_auto_width'>
                    <br />
                    <br />
                    <h2>Cookie Policy</h2>
                    <br />
                    <p className='gray_scale_2 font_size_18'>
                        PrepWize uses cookies to improve your experience. This policy is maintained by Revennt, LLC.
                    </p>

                    <h3>1. What Are Cookies?</h3>
                    <p>
                        Cookies are small text files that are placed on your device to help the site provide a better user experience. They are widely used to make websites work more efficiently, as well as to provide information to the site owners.
                    </p>

                    <h3>2. How We Use Cookies</h3>
                    <p>
                        We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. Cookies help us understand user behavior and improve the functionality of our platform.
                    </p>

                    <h3>3. Types of Cookies We Use</h3>
                    <ul>
                        <li><strong>Essential Cookies:</strong> Necessary for the website to function and cannot be switched off.</li>
                        <li><strong>Performance Cookies:</strong> Help us understand how visitors interact with the site by collecting information anonymously.</li>
                        <li><strong>Functional Cookies:</strong> Allow the website to remember choices you make and provide enhanced functionality.</li>
                        <li><strong>Targeting Cookies:</strong> May be set through our site by our advertising partners to build a profile of your interests and show you relevant ads.</li>
                    </ul>

                    <h3>4. Managing Cookies</h3>
                    <p>
                        You can manage or delete cookies through your browser settings. Disabling some cookies may affect the functionality of the website.
                    </p>

                    <h3>5. Third-Party Cookies</h3>
                    <p>
                        We may allow third-party services to set cookies that track certain behaviors or provide functionality such as analytics and advertising. These cookies are subject to the third party's own privacy policies.
                    </p>

                    <h3>6. Updates to This Policy</h3>
                    <p>
                        We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated effective date.
                    </p>

                    <h3>7. Contact Us</h3>
                    <p>
                        If you have any questions about our use of cookies, please contact us at: <a href="mailto:support@prepwize.ai">support@prepwize.ai</a>
                    </p>
                </div>
            </div>
        </div>

    );
}

export default CookiePolicy;
